const initalState = {
    cityDetailsData: {},
  };
  
  const searchFilter = (state = initalState, action) => {
  
    if (action.type === "cityDetailsData") {
      return { ...state, cityDetailsData: action.payload };
    }
  
    return state;
  };
  
  export default searchFilter;
  